<template>
  <!-- BEGIN: Content-->
  <div class="app-content" style="margin-top: -25px;">
    <div class="content-wrapper container-xxl p-0">

      <div class="content-header row my-1">
        <div class="content-header-left col-md-9 col-12">
          <div class="row breadcrumbs-top">
            <div class="col-12">
              <div v-if="!contactId" class="demo-inline-spacing">
                <div @click="onHandleClick('person')" class="form-check form-check-inline mt-0">
                  <input v-model="infoType" class="form-check-input" type="radio" name="inlineRadioOptions"
                         id="inlineRadio1"
                         value="person"/>
                  <label class="form-check-label" for="inlineRadio1">Person</label>
                </div>
              </div>
              <div class="form-check text-capitalize" v-else>
                <label class="form-check-label">{{ updateFormData.contact_type }}</label>
              </div>
            </div>
          </div>
        </div>
        <div class="content-header-right col-md-3 col-12">
          <div class="float-end">
            <button
                type="button"
                @click="redirectBack"
                class="btn btn-close"
            >
            </button>
          </div>
        </div>
      </div>

      <div class="content-body">
        <div id="user-profile">
          <!-- profile header -->
          <div class="row">
            <div class="col-12">
              <div class="card profile-header profile_header_visibility mb-2">
                <!-- photo and cover photo -->
                <ContactBanner
                    :name="updateFormData.full_name??''"
                    :designation="updateFormData.designation??''"
                    :company_roles_data="updateFormData.company_roles_data??''"
                    :profilePhoto="updateFormData.photo??''"
                    :signaturePhoto="updateFormData.signature_photo??''"
                    :coverPhoto="updateFormData.cover_photo??''"
                    :showProfilePhoto="true"
                    :isEditable="contactId"
                    @photoUploaded="uploadPhoto"
                />

                <!-- tabs pill -->
                <ContactNav
                    :activeTabId="activeTabId"
                    :tabs="tabs"
                    @setActiveTab="setActiveTab"
                    :infoType="infoType"
                />

              </div>
            </div>
          </div>
          <!--/ profile header -->

          <!-- profile info section -->
          <section id="profile-info">
            <div class="row">
              <div class="col-md-12 col-12">

                <div class="card">
                  <component :formData="updateFormData" :items="items" :companyRules="companyRules" @storeContact="storeContact"
                             :is="activeTab" :status="status" />
                </div>

              </div>
            </div>
          </section>
          <!--/ profile info section -->
        </div>

      </div>
    </div>
  </div>
  <Loader v-if="loading"/>
  <!-- END: Content-->
</template>

<script setup>
import {computed, inject, onMounted, ref} from "vue";
import {useRoute, useRouter} from "vue-router";
import Loader from '@/components/atom/LoaderComponent'
import ContactNav from '@/components/molecule/contact/ContactNav.vue'
import BasicInfo from "@/views/page/company/procurement/beneficiary/tabs/person/BasicInfo.vue";
import PhoneNo from "@/views/page/company/procurement/beneficiary/tabs/person/PhoneNo.vue";
import Email from "@/views/page/company/procurement/beneficiary/tabs/person/Email.vue";
import Address from "@/views/page/company/procurement/beneficiary/tabs/person/Address.vue";
import Organizations from "@/views/page/company/procurement/beneficiary/tabs/person/Organizations.vue";
import Education from "@/views/page/company/procurement/beneficiary/tabs/person/Education.vue";
import SkillsExpertise from "@/views/page/company/procurement/beneficiary/tabs/person/SkillsExpertise.vue";
import ExtraActivity from "@/views/page/company/procurement/beneficiary/tabs/person/ExtraActivity.vue";
import ProfessionalReference from "@/views/page/company/procurement/beneficiary/tabs/person/ProfessionalReference.vue";
import ContactBanner from "@/components/molecule/company/hospital/patient/create-update/ContactBanner.vue";

import handleCompanyContact from "@/services/modules/companyContact";
import handleRole from "@/services/modules/role";

import LinkedAccount from "@/views/page/company/procurement/beneficiary/tabs/LinkedAccount.vue";
import Fees from "@/views/page/company/contact/tabs/Fees.vue";
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";

const {
  storeCompanyContact,
  storeCompanyContactsItems,
  storeUpdateContactFile,
  fetchSingleCompanyContact,
  storeAdditionalContactItems,
  fetchSingleCompanyContactItems
} = handleCompanyContact();

const {
  fetchCompanyDefaultRoles
} = handleRole();

const {
  fetchTypes,
} = handleHrPayroll()

const route = useRoute();
const router = useRouter();
const activeTab = ref(BasicInfo)
const activeTabId = ref('basic_info')
const infoType = ref('person');
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false)
const companyRules = ref([])
const updateFormData = ref({})
const items = ref([])
const status = ref([]);

const contactId = computed(() => route.query.contactId)
function getQuery() {
  return `?company_id=${route.params.companyId}`;
}

const redirectBack = () => {
  if (contactId.value) {
    let query = {
      page: 1,
      contactId: contactId.value
    }
    router.push({name: 'beneficiary-register', query});
    return;
  }
  router.back();
}
const onHandleClick = (value) => {
  let routeQuery = Object.assign({}, route.query);
  routeQuery.type = value
  let hashValue = '#basic_info';
  router.push({path: route.path, query: routeQuery, hash: hashValue});
  if (value === 'person') {
    activeTabId.value = 'basic_info';
    activeTab.value = BasicInfo;
    return;
  }

  if (contactId.value) {
    getSingleContact(contactId.value)
  }
}
const tabs = [
  {id: 'basic_info', module: 'person', title: 'Basic Info', component: BasicInfo},
  {id: 'phone', module: 'both', title: 'Phone No', component: PhoneNo},
  {id: 'email', module: 'both', title: 'Email', component: Email},
  {id: 'address', module: 'person', title: 'Address', component: Address},
  {id: 'organization', module: 'person', title: 'Organizations', component: Organizations},
  {id: 'education', module: 'person', title: 'Education', component: Education},
  {id: 'linked_account_org', module: 'organization', type: 'child', title: 'Linked Accounts', component: LinkedAccount},
  {id: 'contact_person_fees', module: 'organization', type: 'child', title: 'Fees', component: Fees},
  {id: 'skills_expertise', module: 'person', type: 'child', title: 'Skills / Expertise', component: SkillsExpertise},
  {id: 'extra_activity', module: 'person', type: 'child', title: 'Extra Activity', component: ExtraActivity},
  {id: 'linked_account_person', module: 'person', type: 'child', title: 'Linked Accounts', component: LinkedAccount},
  {id: 'contact_person_fees', module: 'person', type: 'child', title: 'Fees', component: Fees},
  {
    id: 'professional_reference',
    module: 'person',
    type: 'child',
    title: 'Professional Reference',
    component: ProfessionalReference
  }
]

const uploadPhoto = async (image, type) => {
  loading.value = true
  let form = new FormData();
  form.append('file', image)
  form.append('type', type)

  storeUpdateContactFile(contactId.value, form, getQuery()).then(res => {
    loading.value = false
    if (!res.status) {
      return showError(res.message)
    }
    updateFormData.value[type] = res.data;
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const storeContact = (formData) => {
  let payload = {
    contact_type: infoType.value,
    contact_id: contactId.value,
    active_tab: activeTabId.value,
    ...formData
  }

  if (activeTabId.value === 'basic_info') {
    payload.contact_group_id = payload.contact_group
        ? payload.contact_group.id
        : null;
    payload.contact_owner_id = payload.contact_owner
        ? payload.contact_owner.id
        : null;

    delete payload.contact_group;
    delete payload.contact_owner;
  }

  const validTabs = ['basic_info', 'address'];
  const checkActiveTab = validTabs.includes(activeTabId.value);

  const routeRes = checkActiveTab ? storeCompanyContact(payload, getQuery())
      : storeCompanyContactsItems(payload, getQuery())
  routeRes.then(res => {
    loading.value = false
    if (!res.status) {
      return showError(res.message)
    }

    if (!checkActiveTab) {
      items.value = res.data
    }else {
      let routeQuery = Object.assign({}, route.query)
      routeQuery.contactId = res.data.id
      let hashValue  = '#basic_info';
      router.push({path: route.path, query: routeQuery, hash: hashValue})
      updateFormData.value = res.data
    }
    if (activeTabId.value === 'basic_info') {
      const { religion, url } = formData
      let keys = { religion, url }
      saveAdditionalContactItems(res.data.id, keys, getQuery())
    }
    showSuccess(res.message)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const saveAdditionalContactItems = (contactId, keys, getQuery) => {
  storeAdditionalContactItems(contactId, keys, getQuery).then(res => {
    loading.value = false
    if (!res.status) {
      return showError(res.message)
    }
    updateFormData.value = {...updateFormData.value, ...res.data};
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const getSingleContact = (id) => {
  loading.value = true
  let query = getQuery();
  query += "&active_tab=" + activeTabId.value;
  query += "&call_from=employee";
  const keys = ['blood_group', 'marital_status', 'religion', 'spouse_name', 'url'];
  const keysQueryParam = keys.join(',');
  query += "&keys=" + keysQueryParam;
  fetchSingleCompanyContact(query, id).then(res => {
    loading.value = false
    if (!res.status) {
      return showError(res.message)
    }
    updateFormData.value = res.data
    items.value = res.data.items
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const getSingleContactItems = () => {
  loading.value = true
  let query = getQuery();
  query += "&active_tab=" + activeTabId.value;
  fetchSingleCompanyContactItems(query, contactId.value).then(res => {
    loading.value = false
    if (!res.status) {
      return showError(res.message)
    }
    items.value = res.data
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const getTypes = async () => {
  let query =  `?company_id=${route.params.companyId}`;
  await fetchTypes(query).then(res => {
    if (!res.status){
      status.value = [];
      return
    }

    if (res.data && res.data.status) {
      status.value = res.data.status;
    }

  }).catch(err => {
    console.log(err)
  })
}

onMounted(() => {
  loading.value = true;
  let companyQuery = `?company_id=${route.params.companyId}`
  companyQuery += "&roles=beneficiary";
  const rolesRes = fetchCompanyDefaultRoles(companyQuery)
  Promise.all([
    rolesRes.then(res => {
      if (res.data) companyRules.value = res.data
    }),
    getTypes()
  ])
      .then(() => {
        loading.value = false
      })
      .catch((err) => {
        loading.value = false
      })

  const hashPath = route.hash.substring(1);
  if (hashPath) {
    activeTabId.value = hashPath;
    const tab = tabs.find(item => (item.id === hashPath || item.id === 'more'));
    activeTab.value = tab.component;
  }

  if (contactId.value) {
    getSingleContact(contactId.value)
  }

  if (route.query.type ?? '') {
    infoType.value = route.query.type;
  }
})

const setActiveTab = tab => {
  activeTab.value = tab.component;
  activeTabId.value = tab.id;

  const validTabs = ['basic_info', 'address'];
  const checkActiveTab = validTabs.includes(activeTabId.value);
  if (!checkActiveTab){
    getSingleContactItems()
  }
};

</script>

<style>

.org_icon_col {
  padding-bottom: 5%;
  position: relative;
}

.org_dlt_icon {
  position: absolute;
  right: 0px;
  top: -17px;
}

.button_icon {
  border: none !important;
  padding: 4px 15px !important;
}

.p_left_0 {
  padding-left: 0 !important;
}

.header_txt {
  /* margin-left: -15% !important; */
  justify-content: space-evenly !important;
}

.box_shadow {
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
}

.card_body {
  padding: 2% 2%;
  width: 48%;
  margin: 1%;
  border-radius: 5px
}

@media (max-width: 414px) {
  .card_body {
    width: auto !important;
  }

  ._skill_btn_visibility {
    display: grid !important;
  }

  ._skill_out_visibility {
    display: none !important;
  }

  .org_icon_col {
    padding-bottom: 10% !important;
  }

  .org_dlt_icon {
    top: -8px !important;
  }
}
</style>
<style scoped>

.profile_sub_menu.dropdown-menu {
  min-width: 11rem !important;
}

.profile_sub_menu .nav-pills .nav-link, .nav-tabs .nav-link {
  justify-content: center !important;
}


</style>
